var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFootfail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 58.791,
    viewBox: "0 0 50 58.791",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MDI_shoe-print",
    "data-name": "MDI / shoe-print",
    transform: "translate(3 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Boundary",
    transform: "translate(-0.17 -0.396)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.17,
    height: 47.17,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 46.17,
    height: 46.17,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_shoe-print",
    "data-name": "Path / shoe-print",
    d: "M23.86,30.6c1.383,3.62,1.236,7.387-2.914,8.888-8.535,3.149-10.448-5.121-10.566-5.533L23.86,30.6m-14.8-2.384,12.714-3.149c-.559-3.09.294-6.18.294-9.83,0-4.944-3.914-14.627-10.153-13.067C4.789,3.937,3.759,11.854,4.024,15.68c.353,3.826,4.827,12.008,5.033,12.537M44.785,54.528c-.088.441-2.031,8.682-10.566,5.562-4.12-1.53-4.3-5.3-2.914-8.917l13.479,3.355m6.328-18.247c.294-3.826-.706-11.772-7.858-13.538-6.21-1.619-10.124,8.123-10.124,13.1,0,3.62.824,6.71.324,9.8L46.11,48.789C46.345,48.259,50.789,40.077,51.113,36.281Z",
    transform: "translate(-6.987 -9.003)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootfail);
export default __webpack_public_path__ + "static/media/footfail.c78c42b0e61925d649f2ca779246d8ef.svg";
export { ForwardRef as ReactComponent };